import { tv } from 'tailwind-variants'

export const GridImageCardsStyles = tv({
  slots: {
    root: ['bg-neutral-6 py-5 md:py-10'],
    icon: 'bg-foundation-verde1',
    iconLabel: 'typo-p3 uppercase text-foundation-verde1',
    title: 'md:text-center text-foundation-verde1 typo-h2 md:typo-h1 md:leading-10',
    subTitle: 'md:text-center text-foundation-verde1 text-base font-normal font-mplus leading-6',
    cardTitle: 'text-foundation-verde1',
    cardSubTitle: 'text-foundation-verde1 ',
    description: '',
    boxTitle: 'typo-h2 text-neutral-6',
    boxDescription: 'typo-p1 text-neutral-6',
    cardStyle: ''
  },
  variants: {
    appearance: {
      default: {
        root: 'bg-neutral-6'
      },
      'costa-do-sauipe': {
        root: 'bg-foundation-azul2',
        title: 'text-neutral-6',
        subTitle: 'text-neutral-6',
        cardTitle: 'text-neutral-6',
        cardSubTitle: 'text-neutral-6',
        boxTitle: 'text-neutral-6',
        boxDescription: 'text-neutral-6',
        icon: 'text-neutral-6',
        iconLabel: 'text-neutral-6'
      },
      'rio-quente': {
        root: 'bg-foundation-verde4',
        title: 'text-foundation-verde1',
        subTitle: 'text-foundation-verde1',
        boxTitle: 'text-foundation-verde1',
        boxDescription: 'text-foundation-verde1',
        cardTitle: 'text-neutral-6',
        cardSubTitle: 'text-neutral-6',
        icon: 'text-foundation-verde1',
        iconLabel: 'text-foundation-verde1'
      }
    }
  },
  defaultVariants: {
    appearance: 'default'
  }
})
